import React from 'react'
import './alert.css'
class AuthenticationAlert extends React.Component{
	constructor(props){
		super(props)
	}
	render(){
		return(
			<div className="return-role-notice">
			   <span className="return-role-title ">龙之谷账号鉴定规则：</span>
					
			   <span>1、绑定手机下所有盛趣账号，超过90天均未登录任何盛趣的游戏；</span>
			   <span>2、在2019年9月26日后回归登录龙之谷游戏。</span>
		    </div>
			)

	}
}
export default AuthenticationAlert




// WEBPACK FOOTER //
// ./src/component/return-get-alert/authentication-alert.js